
import {GET_VEHICLE_LOGS_STARTED} from "../../reducers/vehicleReducer";


export const getVehicleLogsStarted = () =>{
    return {
        type: GET_VEHICLE_LOGS_STARTED,
        payload: {}
    }
}